<template>
    <div>
        <CRow class="w-100">
            <CCol md="12" lg="12" sm="12" xs="12">
                <HomeProceesVue v-if="page == 'home'" @changePage="changePage" @setView="setView" />
                <PaymentsVue class="pt-1" v-if="page == 'payments'" @mtdBack="mtdBack" />
            </CCol>
        </CRow>
    </div>
</template>

<script>

import HomeProceesVue from '../../components/processAdmin/Home.vue';
import PaymentsVue from '../../components/processAdmin/PaymentsCompanies.vue';


export default {
    components: {
        HomeProceesVue,
        PaymentsVue,
    },
    data() {
        return {
            page: 'home',
        }
    },
    methods: {
        changePage(page) {
            this.page = page;
            this.$emit("mtdViewFooter", false, 'home');
        },
        returnHome() {
            this.page = 'home';
            this.$emit("mtdViewFooter", true, 'home');
        },
        hasRoles(roles) {
            return roles.some(role => this.userRoles.includes(role));
        },
        mtdBack: function () {
            this.page = 'home';
            // this.$emit('setView', 'home')
        },
        setView: function () {
            this.$emit('setView', 'home')
        }
    }
};
</script>